<template>
  <div v-if="showModal" class="modal-container">
    <div class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"></div>

    <div
      class="modal-content relative bg-white max-w-lg w-full max-h-[90vh] m-auto flex-col flex rounded-lg shadow-lg"
    >
      <div class="w-full border-b-[1px] mb-4 px-6 py-4">
        <h2 class="text-[18px] text-grayDark font-bold">Rename Task</h2>
      </div>

      <form @submit.prevent="submitRenameTask" class="overflow-y-auto px-6">
        <div class="space-y-4 mb-4">
          <div>
            <label class="block text-[13px] font-medium text-gray-700"
              >Task Title</label
            >
            <input
              v-model="taskTitle"
              type="text"
              placeholder="Enter new task title"
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required
            />
          </div>
        </div>
        <div class="flex justify-end mb-4 text-[14px]">
          <button
            type="button"
            class="mr-4 py-2 px-4 bg-primaryLight border border-grayLight text-grayDark rounded"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="flex items-center gap-2 py-2 px-4 bg-primaryDarkBg w-[146px] h-[42px] text-white rounded"
          >
            <img src="@/assets/dashboard/add.svg" alt="Save icon" class="h-4" />
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";

export default {
  name: "RenameTaskModal",
  components: {},
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    task: {
      type: Object,
      default: null, // Make task prop nullable
    },
  },
  data() {
    return {
      taskTitle: this.task?.title || "",
    };
  },
  methods: {
    async submitRenameTask() {
      if (!this.taskTitle.trim()) {
        this.$toast.error("Task title cannot be empty.");
        return;
      }

      try {
        const payload = { title: this.taskTitle };
        await apiClient.put(`/web/tasks/${this.task.task_id}?project_id=${this.task.project_id}`, payload);

        this.$toast.success("Task renamed successfully!");
        this.$emit("task-renamed", { ...this.task, title: this.taskTitle });

        setTimeout(() => {
          this.$emit("close");
        }, 500);
      } catch (error) {
        console.error("Error renaming task:", error);
        this.$toast.error(error.response?.data?.message || "An unexpected error occurred.");
      }
    },
    clearErrorMessage() {
      // no-op retained for compatibility
    },
  },
  watch: {
    task(newTask) {
      this.taskTitle = newTask?.title || "";
    },
  },
};
</script>

<style scoped>
.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  z-index: 50;
}

.modal-content {
  position: relative;
  z-index: 60;
}
</style>
